var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"conn_voer",attrs:{"show":_vm.show}},[_c('div',{staticClass:"connection-empty"},[_c('p',[_vm._v("只有通过认证的专业买家和参展商才能浏览")]),_c('p',[_vm._v("完成认证即可继续浏览")]),_c('van-button',{staticClass:"btn",attrs:{"round":"","color":"#f85b0f"},on:{"click":_vm.gotoAuth}},[_vm._v("认证成为专业买家")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }